import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import TextFieldSimple from "../../../textfield/TextFieldSimple";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";

const ModalPerformRefund = ({
                                open,
                                onClose,
                                titleModal,
                                issue,
                                refund,
                                setRefund,
                                submit
                            }) => {

    return (
        <div>
            <Dialog open={open}>
                <DialogTitle textAlign="center">{titleModal}</DialogTitle>
                <DialogContent>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        '& > *': {
                            marginRight: '10px',
                        }
                    }}>
                        <TextFieldSimple
                            label="Выдано"
                            value={issue}
                            field={'issue'}
                            disabled={true}
                        />
                        <TextFieldSimple
                            label="Вернуть"
                            value={refund}
                            setValue={setRefund}
                            field={'refund'}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={onClose}/>
                    <ButtonAdd
                        text={"Вернуть"}
                        onClick={submit}/>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ModalPerformRefund;